import React, { Fragment } from 'react';

const SelectField = (props) => {
    const { data = [], selectClassName = '', placeholder = '', selectedHandler, context = '' } = props;
    return (
        <Fragment>
            <select className={selectClassName} onChange={(e) => selectedHandler(e.target.value, context)}>
                {data.map(innerData => {
                    return <option value={innerData}>{innerData}</option>
                })}
            </select>
            <span className="b2cform__field--codetext">{placeholder}</span>
        </Fragment>
    )
}

export default SelectField;
